module.exports = __webpack_public_path__ + "static/media/selenium.1b7ce531.svg";